// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__4Sj2J","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__Px5M4"};